var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.915 5.333c-.351 0-.516-.223-1.22-.858L.203 3.09a.58.58 0 010-.883.69.69 0 01.95 0l1.491 1.387a.436.436 0 00.271.126c.136 0 .271-.126.271-.126L6.847.189a.69.69 0 01.95 0 .58.58 0 010 .883L4.136 4.475c-.72.74-.87.858-1.22.858z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCheck);
export default __webpack_public_path__ + "static/media/orange-check.7c8d95ed40d28ccdbd716316cc73a62d.svg";
export { ForwardRef as ReactComponent };